<section class="eventq-collapsible-search-panel" [class.eventq-collapsible-search-panel--closed]="!open()">
  <button type="button" class="eventq-collapsible-search-panel__header" (click)="toggleOpen()">
    <span>{{ title() }}</span>
    <span class="eventq-collapsible-search-panel__chevron">{{ open() ? '−' : '+' }}</span>
  </button>
  @if (open()) {
    <div class="eventq-collapsible-search-panel__body">
      <eventq-searchable-list
        appearance="panel"
        selectionMode="single"
        [fillHeight]="fillHeight() && !padListBottom()"
        [columns]="itemColumns"
        [rows]="itemRows()"
        [showRows]="showItemRows()"
        [selectedIds]="selectedIds()"
        [searchQuery]="searchQuery()"
        [searchPlaceholder]="searchPlaceholder()"
        [listAriaLabel]="title()"
        (searchQueryChange)="searchQueryChange.emit($event)"
        (itemSelect)="itemSelect.emit($event)"
      >
        <div eventqSearchableListExtra class="eventq-collapsible-search-panel__custom">
          <ng-content select="[eventqCollapsibleSearchPanelBody]" />
        </div>
      </eventq-searchable-list>
      @if (fillHeight() && padListBottom()) {
        <div class="eventq-collapsible-search-panel__filler" aria-hidden="true"></div>
      }
    </div>
  }
</section>
